module.exports = __webpack_public_path__ + "media/images/favicon-32x32-c0fb98b4.png";